import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import { CaretDown, House, HardHat, Users, Briefcase, ArrowsLeftRight, ShieldCheck, ListChecks } from '@phosphor-icons/react';
import AdminApproval from './AdminApproval';

const AdminNav = ({ currentView }) => {
  const [open, setOpen] = useState(false);
  const [showApprovals, setShowApprovals] = useState(false);
  const { setAdminView } = useContext(AuthContext);
  const navigate = useNavigate();

  const items = [
    { id: 'owner', label: 'Owner Dashboard', icon: House, action: () => { setAdminView('owner'); navigate('/dashboard'); } },
    { id: 'gc', label: 'GC Dashboard', icon: HardHat, action: () => { setAdminView('gc'); navigate('/dashboard'); } },
    { id: 'contractors', label: 'Contractor Directory', icon: Users, action: () => navigate('/contractors') },
    { id: 'jobs', label: 'All Jobs', icon: Briefcase, action: () => navigate('/jobs') },
    { id: 'approvals', label: 'Profile Approvals', icon: ShieldCheck, action: () => setShowApprovals(true) },
  ];

  return (
    <>
      <div className="relative">
        <button
          data-testid="admin-nav-dropdown"
          onClick={() => setOpen(!open)}
          className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all"
          style={{
            background: 'rgba(0, 212, 255, 0.1)',
            border: '1px solid rgba(0, 212, 255, 0.2)',
            color: 'var(--cyan)'
          }}
        >
          <ArrowsLeftRight size={14} weight="bold" />
          Admin
          <CaretDown size={12} weight="bold" style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }} />
        </button>

        {open && (
          <>
            <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
            <div data-testid="admin-nav-menu" className="absolute right-0 top-10 z-50 w-56 rounded-xl overflow-hidden py-1.5"
              style={{ background: 'var(--bg-panel)', border: '1px solid var(--border-primary)', boxShadow: '0 16px 48px rgba(0,0,0,0.5)' }}>
              {items.map(item => {
                const Icon = item.icon;
                const isActive = (item.id === 'owner' && currentView === 'owner') || (item.id === 'gc' && currentView === 'gc');
                return (
                  <button
                    key={item.id}
                    data-testid={`admin-nav-${item.id}`}
                    onClick={() => { item.action(); setOpen(false); }}
                    className="w-full flex items-center gap-3 px-4 py-2.5 text-left text-xs font-medium transition-colors"
                    style={{
                      color: isActive ? 'var(--gold)' : 'var(--text-secondary)',
                      background: isActive ? 'rgba(201,206,211,0.06)' : 'transparent',
                    }}
                    onMouseEnter={(e) => { if (!isActive) e.currentTarget.style.background = 'rgba(201,206,211,0.06)'; }}
                    onMouseLeave={(e) => { if (!isActive) e.currentTarget.style.background = 'transparent'; }}
                  >
                    <Icon size={16} weight={isActive ? 'fill' : 'duotone'} />
                    {item.label}
                    {isActive && <span className="ml-auto w-1.5 h-1.5 rounded-full" style={{ background: 'var(--gold)' }} />}
                  </button>
                );
              })}
            </div>
          </>
        )}
      </div>
      {showApprovals && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(8px)' }}>
          <div className="w-full max-w-2xl rounded-2xl overflow-hidden max-h-[80vh] overflow-y-auto" style={{ background: 'var(--bg-panel)', border: '1px solid var(--border-primary)', boxShadow: '0 25px 80px rgba(0,0,0,0.5)' }}>
            <div className="flex items-center justify-between px-6 py-4" style={{ borderBottom: '1px solid var(--border-subtle)' }}>
              <h2 className="text-lg font-bold font-heading" style={{ color: 'var(--gold-light)' }}>Profile Approvals</h2>
              <button data-testid="close-approvals" onClick={() => setShowApprovals(false)} className="text-sm font-semibold" style={{ color: 'var(--text-muted)' }}>Close</button>
            </div>
            <div className="p-6">
              <AdminApproval />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminNav;
